import {
    SEND_CONTACT,
    CHRISTMAS_BOOKING,
    GET_TOURISTS_TERMS
} from '../actions/types';

const initialState = {
    touristsTerms: ''
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SEND_CONTACT:
            return {
                ...state,
                success: action.payload.success,
                message: action.payload.message
            }
        case CHRISTMAS_BOOKING:
            return {
                success: true,
                ...state
            };
        case GET_TOURISTS_TERMS:
            return {
                ...state,
                touristsTerms: action.payload
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/commonReducer.js